import { render, staticRenderFns } from "./CheckedBoxIcon.vue?vue&type=template&id=b58c1c46&scoped=true&"
import script from "./CheckedBoxIcon.vue?vue&type=script&lang=js&"
export * from "./CheckedBoxIcon.vue?vue&type=script&lang=js&"
import style0 from "./CheckedBoxIcon.vue?vue&type=style&index=0&id=b58c1c46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58c1c46",
  null
  
)

export default component.exports